import { defineComponent as _defineComponent } from 'vue'
import { customersService } from '@/services/tenants.service';
import { Customer } from '@/models/tenant';
import { Mode } from '@/models/enums/Mode';
import { CustomerCutConfig } from '@/models/customerCutConfig';
import { computed, reactive, ref } from 'vue';
import useVuelidate from '@vuelidate/core';
import { required } from '@/utils/validation';
import { helpers, maxLength } from '@vuelidate/validators';
import { useI18n } from '@/composables/i18n';
import { toastService } from '@/library-services/toast.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerCutGasTypeConfig',
  props: {
    customer: null
  },
  emits: ["update"],
  setup(__props: any, { emit }: { emit: ((e: 'update', value: Customer) => void), expose: any, slots: any, attrs: any }) {

const props = __props as {
  customer: Customer;
};





const editCustomer = reactive(Customer.GetCopy(props.customer));
const editCustomerInitial = reactive(Customer.GetCopy(props.customer));
const mode = ref(Mode.View);
const isSubmitting = ref(false);

const { t } = useI18n();

const channelRegexValidator = helpers.withMessage(
  () => t('form.input_validation_allowed_chars').toString(),
  helpers.regex(/^[\w\p{L} .,\-]{1,16}$/u),
);
const validations = {
  channel0Name: {
    required,
    maxLength: maxLength(16),
    regex: channelRegexValidator,
  },
  channel1Name: {
    required,
    maxLength: maxLength(16),
    regex: channelRegexValidator,
  },
  channel2Name: {
    required,
    maxLength: maxLength(16),
    regex: channelRegexValidator,
  },
  channel3Name: {
    required,
    maxLength: maxLength(16),
    regex: channelRegexValidator,
  },
};
const v$ = useVuelidate(validations, editCustomer);

function startEdit() {
  mode.value = Mode.Edit;
}

async function onSubmit() {
  isSubmitting.value = true;
  if (isEditMode.value) {
    await customersService
      .updateCutConfig(
        new CustomerCutConfig(
          editCustomer.id,
          editCustomer.channel0Name,
          editCustomer.channel1Name,
          editCustomer.channel2Name,
          editCustomer.channel3Name,
        ),
      )
      .then(async () => {
        toastService.success('tenant.update_success');
        await customersService.store.update(editCustomer);
        emit('update', editCustomer);
        Object.assign(editCustomerInitial, editCustomer);
      })
      .finally(() => (isSubmitting.value = false));
  }
  mode.value = Mode.View;
}

function cancelEdition() {
  Object.assign(editCustomer, editCustomerInitial);
  mode.value = Mode.View;
}

function getValidationMessage(fieldName: keyof typeof editCustomer) {
  return v$.value[fieldName].$errors[0]?.$message;
}

const isEditMode = computed((): boolean => mode.value === Mode.Edit);
const isViewMode = computed((): boolean => mode.value === Mode.View);

return { __sfc: true,props, emit, editCustomer, editCustomerInitial, mode, isSubmitting, t, channelRegexValidator, validations, v$, startEdit, onSubmit, cancelEdition, getValidationMessage, isEditMode, isViewMode }
}

})